import { useEffect } from 'react';

/**
 * Reset the text after a certain amount of time
 */
export const useTemporaryTextEffect = (
    text: string | undefined,
    setText: (newText: string | undefined) => void,
    timeout: number,
) => {
    useEffect(() => {
        setText(text);
        const timer = setTimeout(() => {
            setText(undefined);
        }, timeout);

        return () => clearTimeout(timer);
    }, [setText, text, timeout]);
};
